import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCamera = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.154 4a.75.75 0 0 0-.604.305L6.64 6.9H4.173a2.16 2.16 0 0 0-1.541.65A2.21 2.21 0 0 0 2 9.1v8.7c0 .579.226 1.137.632 1.55.406.415.96.65 1.541.65h15.654a2.16 2.16 0 0 0 1.541-.65c.406-.413.632-.971.632-1.55V9.1c0-.579-.226-1.137-.631-1.55a2.16 2.16 0 0 0-1.542-.65H17.36l-1.91-2.595A.75.75 0 0 0 14.846 4zm-1.53 4.095L9.533 5.5h4.933l1.91 2.595a.75.75 0 0 0 .604.305h2.846a.66.66 0 0 1 .47.2c.129.13.203.31.203.5v8.7c0 .19-.074.37-.202.5a.66.66 0 0 1-.471.2H4.173a.66.66 0 0 1-.47-.2.71.71 0 0 1-.203-.5V9.1c0-.19.074-.37.202-.5a.66.66 0 0 1 .471-.2H7.02a.75.75 0 0 0 .604-.305m1.924 4.63c0-1.401 1.11-2.513 2.452-2.513 1.34 0 2.452 1.112 2.452 2.513S13.34 15.237 12 15.237s-2.452-1.111-2.452-2.512M12 8.712c-2.196 0-3.952 1.81-3.952 4.013S9.804 16.737 12 16.737s3.952-1.81 3.952-4.012c0-2.203-1.756-4.013-3.952-4.013"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCamera;
